import type { ErrorByScreen } from '../../lib/api.js';
import { formatNumber } from '../../lib/formatters.js';
import { AuthMiniBar } from './AuthMiniBar.js';

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business 画面別エラーテーブルの 1 行。screen / event / count / uniqueSessions / loggedIn vs anonymous を描画する。
 * @graph-connects formatNumber [calls] 数値フォーマット
 * @graph-connects AuthMiniBar [calls] ログイン状態別ミニバー描画
 */
export function ScreenErrorRow({ row }: { row: ErrorByScreen }) {
  return (
    <tr className="border-b border-[var(--color-border)] hover:bg-[var(--color-bg-hover)]">
      <td className="py-1.5 px-2 text-[var(--color-text-secondary)] truncate max-w-[140px]">
        {row.screen}
      </td>
      <td className="py-1.5 px-2 text-[var(--color-text-secondary)]">{row.event}</td>
      <td className="py-1.5 px-2 text-right font-mono text-[var(--color-text-primary)]">
        {formatNumber(row.count)}
      </td>
      <td className="py-1.5 px-2 text-right font-mono text-[var(--color-text-muted)]">
        {formatNumber(row.uniqueSessions)}
      </td>
      <td className="py-1.5 px-2">
        <AuthMiniBar loggedIn={row.loggedInCount} anonymous={row.anonymousCount} />
      </td>
    </tr>
  );
}
